// https://en.wikipedia.org/wiki/Count%E2%80%93min_sketch


// example:
// Stream = {A,B,A,B,D,A......}
// define 4 hash functions H1, H2, H3, H4, Hi: (event) -> [0, 5]
// define matrix X = martix[4*6]
// event A: H1(A) = 1, H2(A) = 3, H3(A) = 1, H4(A) = 2
//          X[1, 1]++, X[2, 3]++, X[3, 1]++, X[4, 2]++
// event B: H1(B) = 3, H2(B) = 5, H3(B) = 3, H4(B) = 1
//          X[1, 3]++, X[2, 5]++, X[3, 3]++, X[4, 1]++
// ......
// query frequency of A:
//    because: H1(A) = 1, H2(A) = 3, H3(A) = 1, H4(A) = 2
//    so possible count set: Y={X[1, 1], X[2, 3], X[3, 1], X[4, 2]}
//    frequency of A = min(Y)

// w columns, d rows
// w = [e/ε], d = [ln 1/δ], where the error in answering a query is within an additive factor of ε with probability 1 − δ, and e is Euler's number.
const CountMinSketch = ({
  matrix, // w * d
  w, // columns
  d, // rows
}) => {
  const hashs = [];
  for (let i = 0; i < d; i++) {
    hashs[i] = universalHash(i, w);
  }

  const addKey = (key) => {
    for (let i = 0; i < d; i++) {
      const h = hashs[i](key);
      // matrix[i, h]
      matrix[i * w + h]++;
    }
  };

  const getKeyFrequency = (key) => {
    let min = Infinity;

    for (let i = 0; i < d; i++) {
      const h = hashs[i](key);
      min = Math.min(min, matrix[i * w + h]);
    }

    return min;
  };

  const getMatrix = () => {
    return matrix;
  };

  return {
    addKey,
    getKeyFrequency,
    getMatrix,
  };
};

// epsilon, eg 0.001
// delta, eg 0.99
const initMatrix = (epsilon, delta) => {
  const w = Math.floor(Math.E / epsilon);
  const d = Math.floor(Math.log(1 / (1 - delta)));

  const matrix = [];
  for (let i = 0; i < w * d; i++) {
    matrix[i] = 0;
  }

  return {
    w,
    d,
    matrix
  };
};

// str: string to hash
// a: int
// b: int
const universalHash = (a, p) => (str) => {
  let h = 0;

  for (let i = 0; i < str.length; i++) {
    const code = str[i].charCodeAt();

    h = ((h * a) + code) % p;
  }

  return h;
};

export {
  CountMinSketch,
  initMatrix,
};
